/**
 * demoService — thin orchestrator
 *
 * Merges all domain-scoped demo services into a single object that matches
 * the shape callers expect. Domain files own the actual mock data; this file
 * only spreads them together.
 *
 * Domain modules:
 *   demoEmployees.ts   — employees, teams, stats, AI analysis, cohort/DEI
 *   demoEvaluations.ts — evaluation periods, assignments, results, appeals
 *   demoOrganization.ts — org tree, companies, committees, MBO/KPI, ranks
 *   demoPayroll.ts     — payroll, leave, training, workflow, all compliance stubs
 */

import { demoEmployeesService } from './demoEmployees';
import { demoEvaluationsService } from './demoEvaluations';
import { demoOrganizationService } from './demoOrganization';
import { demoPayrollService } from './demoPayroll';
import { demoWeeklyReportsService } from './demoWeeklyReports';
import { demoAttendanceService } from './demoAttendance';
import { demoOvertimeService } from './demoOvertime';
import { demoOnboardingService } from './demoOnboarding';
import { demoLeaveRequestsService } from './demoLeaveRequests';

export const demoService = {
  ...demoEmployeesService,
  ...demoEvaluationsService,
  ...demoOrganizationService,
  ...demoPayrollService,
  ...demoWeeklyReportsService,
  attendance: demoAttendanceService,
  overtime: demoOvertimeService,
  onboarding: demoOnboardingService,
  leaveRequests: demoLeaveRequestsService,
} as any;
